import { render, staticRenderFns } from "./PracticasCurriculares.vue?vue&type=template&id=33a5d1a3&"
import script from "./PracticasCurriculares.vue?vue&type=script&lang=js&"
export * from "./PracticasCurriculares.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports